// Mirrors the backend `ChallengeStatus` enum (see /api/swagger/v1/swagger.json).
export enum EChallengeStatus {
    UNKNOWN = 'Unknown',
    DRAFT = 'Draft',
    PUBLISHED = 'Published',
    READY_TO_START = 'ReadyToStart',
    CREATING_LOBBY = 'CreatingLobby',
    IN_PROGRESS = 'InProgress',
    FAIR_PLAY = 'FairPlay',
    FINISHED = 'Finished',
    CANCELED = 'Canceled',
    SUSPICIOUS = 'Suspicious',
    EXPIRED = 'Expired',
}

export enum EChallengeStatusName {
    PENDING = 'Pending',
    WAITING_FOR_OPPONENT = 'Waiting for opponent',
    ACCEPTED = 'Accepted',
    LIVE = 'LIVE'
}
